export default __webpack_public_path__ + "static/bestburger-035b3cc9bde523e65d1fc49f720f0222.png";